<template>
  <div class="photo-container" :style="{width: `${width}`, height: `${height}`}">
    <!-- <img :src="image" > -->
    <img v-lazy="image" >
  </div>
</template>

<script>
  export default {
    props: ['image', 'width', 'height']  
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .photo-container {
      display: flex;
      padding: 2.667vw;
      border-radius: 8px;
      background:rgba(255,255,255,1);
      box-shadow: 0px 0px 29px 2px rgba(29,117,217,0.2);
      margin: auto;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
</style>
